<script>
import RightLayout from '../layouts/rightLayout'
import {DateUtil} from '@/utils/date.js'
let date = new Date()
var year = date.getFullYear()
var month = date.getMonth() + 1
var initmonth = year + ' 年 ' + month + ' 月 '
export default {
  components: {
    RightLayout
  },
  data () {
    return {
      nowmonth: initmonth,
      year: year,
      month: month,
      messageList: [],
      receiveTimeStr: ''
    }
  },
  watch: {
  },
  created () {
    this.loadAllData()
  },
  methods: {
    // 重新加载
    loadAllData () {
    // 受信時間截取年月
      let receiveTimeStr
      if (this.month < 10) {
        receiveTimeStr = this.year + '0' + this.month
        this.receiveTimeStr = receiveTimeStr
      } else {
        receiveTimeStr = this.year + '' + this.month
        this.receiveTimeStr = receiveTimeStr
      }
      // alert(receiveTimeStr)
      this.$axios.get('shift/queryMessageInfoList', {params: {receiveTimeStr: this.receiveTimeStr}})
        .then(response => {
          let messageList = response.data.messageInfoList
          this.messageList = messageList
        })
        .catch(error => {
          console.log(error)
        })
    },
    goback () {
      this.$router.go(-1)
    },
    // 转化受信時間 将yyyyMMddHHmm转化为 yyyy/mm/dd HH:mm
    convertDate (date) {
      return DateUtil.yearMonthDayandTime(date)
    },
    leftnowmonth () {
      if (this.month === 1) {
        this.month = 12
        this.year--
      } else { this.month-- }
      this.nowmonth = this.year + ' 年 ' + this.month + ' 月 '
      this.loadAllData()
    },
    rightnowmonth () {
      if (this.month === 12) {
        this.month = 1
        this.year++
      } else { this.month++ }
      this.nowmonth = this.year + ' 年 ' + this.month + ' 月 '
      this.loadAllData()
    }
  }
}
</script>

<template>
  <right-layout>
    <div class="col-md-12 column" style="width:100%;display:flex;flex-direction: column;flex:1;margin-bottom: 30px;margin-top:18px">
      <div class="row clearfix" style="flex:0 0 40px;position: relative;">
        <div style="position: absolute;width: 100%;" class="F3-M-27">
          メッセージ
        </div>
        <div class="col-md-2 column headerleft F1-R-19" style="vertical-align: bottom;margin-left:25px">
          <input type="button" value="戻る" @click="goback()" />
        </div>
      </div>
      <div class="row clearfix" style="flex:0 0 10px;position: relative;margin-top:-5px">
        <div style="position: absolute;width: 100%;">
          <hr class="hrheader">
        </div>
      </div>
      <div class="row clearfix" style="flex:0 0 10px;position: relative;margin-top:15px;margin-bottom:20px">
        <div style="position: absolute;width: 100%;">
          <!-- 日期 -->
          <div class="row clearfix">
            <div class="col-md-5 column" style="margin-top:10px">
              <img src="@/assets/button/triangle_blue_left_button.png" @click="leftnowmonth" class="img-style" style="float:right;">
            </div>
            <div class="col-md-2 column nowmonth F1-R-27">{{nowmonth}}</div>
            <div class="col-md-5 column" style="margin-top:10px">
              <img src="@/assets/button/triangle_blue_right_button.png" @click="rightnowmonth" class="img-style" style="float:left;">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 column " style="display:flex;flex-direction: column;margin-top:20px">
        <div class="table-container" style="margin-left:0px;margin-right:0px;height:65vh;">
          <div class="table-header" style="padding-right:10px;">
            <table>
              <thead>
                <!--受信時間、メッセージ内容-->
                <tr class="theader bgc9 F2-R-15">
                  <td class="message-receiveTime htd" style="border-right:1px solid rgb(190,190,190)">受信時間</td>
                  <td class="message-content htd">内容</td>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-body scrollbar">
            <table class="table">
              <tr class="contenttr bgc5h F3-R-18" v-for='message in messageList' v-bind:key="message.number">
                <td class="bodytext message-receiveTime" style="border-right:1px solid rgb(255,255,255)">{{convertDate(message.receiveTime)}}</td>
                <td class="bodytext message-content">
                  <div class="flexDiv">
                    <div class="flexVcenter">{{message.message}}</div>
                    <div class="flexVcenter">&nbsp;&nbsp;&nbsp;</div>
                    <div class="flexVcenter" v-if="message.type==='06'">
                      <img src="@/assets/delay_mark_mid.png">
                    </div>
                    <div class="flexVcenter" v-else-if="message.type==='10'">
                      <img  src="@/assets/attention_mark_mid.png">
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </right-layout>
</template>

<style lang="scss" scoped>@import "../../assets/css/C00.css";
.name-strong {
  font-size: 30px;
}

.user-btn {
  width: 200px
}

.headerleft {
  width: 210px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}

.headerleft input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-align: left;
  // font-weight: bold;
  text-indent: 30px;
  // font-size: 20px;
}

.hrheader {
  background-color: rgb(148, 148, 148);
  height: 1px;
  width: 600px;
}

td {
  width: 18%;
}

tr:hover {
  background-color: rgb(110, 110, 110);
}

.tb-header {
  padding-right: 10px;
}

tr:hover {
  background-color: rgb(110, 110, 110);
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-left: 5px;
  margin-right: 5px;
  table-layout: fixed;
}

.bodytext {
  padding-left: 15px;
  text-align: left;
}

.table>tbody>tr>td {
  padding-top: 13px;
}

.htd {
  padding: 5px;
}

.message-receiveTime {
  width: 12.5%;
}

.message-content {
  width: 87.5%;
}

.nowmonth {
  margin-top: 10px;
  height: 45px;
  line-height: 45px;
  font-size: 28px;
  font-weight: bold;
}

.img-style {
  width: 20px;
  padding-top: 10px;
}

.flexDiv {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flexVcenter {
  display: flex;
  align-items: center;
}
.icon {
  height: 25px;
  width: 25px;
}
@media screen and (max-device-width: 1480px) {
   .bodytext {
     font-size: 10px;
   }
}

</style>



// WEBPACK FOOTER //
// src/router/views/MessageInfoList.vue